import { AxiosPromise } from 'axios';
import { http } from 'services';

import * as Types from './types';
import { getCaptchaToken } from 'helpers/captcha';

export const List = async ({
  params,
}: {
  params: Types.IParams;
}): Promise<AxiosPromise<{ data: { content: Types.IApi.News.Response[]; }; }>> => {
  const token = await getCaptchaToken()

  return http.request.get<{ data: { content: Types.IApi.News.Response[] } }>(`/admin/open_source/news`, {
    params: {
      page: params.page - 1,
      size: params.limit
    },
    headers: {
      ...(token ? { 'X-Turnstile-Token': token } : null)
    }
  });
};

export const Single = async ({ id }: Types.IApi.News.Request): Promise<AxiosPromise<{ data: Types.IApi.News.Response; }>> => {
  const token = await getCaptchaToken()
  return http.request.get<{ data: Types.IApi.News.Response }>(`/admin/open_source/news/${id}`, {
    headers: {
      ...(token ? { 'X-Turnstile-Token': token } : null)
    }
  });
};
